/* HUMAC Termékiránytű — chipsor, gond-tábla, csomagépítő. Forrás: Shopify expert / 2026-10-19_termekiranytu-bundle/src/oldal.js — a témán NE szerkeszd kézzel.
   Az artifact (src/oldal.html <script>) logikája; a termékadat és a kedvezmény-beállítás a #hti-data JSON-ból jön (a section.liquid tölti
   all_products-ból), így variáns-id és ár itt nincs. Itt csak az oldal szövege él (nevek, gondok). */
(function(){
  var D = JSON.parse(document.getElementById("hti-data").textContent);
  var NEV = {por:"HUMAC® Natur Bio Aktív Por",marine:"HUMAC® Marine tabletta",detox:"Immunitás & Detox jutifalat",synbio:"Allergia & Vakarózás jutifalat",
    help:"HUMAC® Help krém",mist:"HUMAC® Mist permet",bubbles:"HUMAC® Bubbles sampon",dental:"HUMAC® Dental fogpor",omega:"HUMAC® Omega-3 halolaj"};
  // a bolt egy-variánsos terméknél "Default Title"-t ad; ahol minden variáns egy árú (Bubbles), a kártya a kiszerelést mutatja
  var KISZ = {detox:"60 db",synbio:"60 db",mist:"100 ml",bubbles:"250 ml",dental:"tégely",omega:"250 ml"};
  var SORREND = ["por","marine","detox","synbio","help","mist","bubbles","dental","omega"];
  var KARTYA = {por:"por",marine:"marine",detox:"detox",synbio:"szimbiotikum",help:"help",mist:"mist",bubbles:"sampon",dental:"dental",omega:"omega"};
  var INGYEN = D.ingyen, GLS = D.szall;
  // kikapcsolt kedvezménynél nincs lépcső: a link discount nélkül megy, a kedvezmény-elemek nincsenek a DOM-ban
  var SZINT = D.aktiv ? D.szint.filter(function(s){return s.min&&s.pct;}).sort(function(a,b){return b.min-a.min;}) : [];

  // a bolt variáns-címe ("100g", "2.5kg", "30db") az artifact alakjára ("100 g", "2,5 kg", "30 db")
  function cim(t){return t.replace(".",",").replace(/(\d)([a-z])/gi,"$1 $2");}
  var P = {};
  D.t.forEach(function(r){
    if(!r.url) return; // all_products üres: a kártya marad, csomagba nem tehető
    var p = P[r.k] = P[r.k] || {nev:NEV[r.k],kep:D.kep[r.k],url:r.url,v:[]};
    r.v.forEach(function(v){
      if(!v.ok) return;
      var c = v.n === "Default Title" ? KISZ[r.k] : cim(v.n);
      p.v.push({id:v.id,c:c,n:(r.e !== "-" ? r.e + " " : "") + c,ar:v.ar});
    });
  });
  SORREND.forEach(function(k){if(P[k]&&!P[k].v.length)delete P[k];});

  function ft(n){return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g," ")+" Ft";}
  function $(s,r){return (r||document).querySelector(s);}
  function el(t,c,h){var e=document.createElement(t);if(c)e.className=c;if(h!=null)e.innerHTML=h;return e;}
  function minAr(p){return Math.min.apply(null,p.v.map(function(v){return v.ar;}));}
  function tobbAr(p){var m=minAr(p);return p.v.some(function(v){return v.ar!==m;});}

  /* --- kártyák és forma-tábla: ár, kiszerelés, termék-URL a boltból --- */
  SORREND.forEach(function(k){
    var c=document.getElementById(KARTYA[k]), p=P[k], ar=$(".hti-ar",c), td=$('.hti-tabla-ar[data-k="'+k+'"]');
    if(!p){
      ar.innerHTML="<span>lásd a termékoldalon</span>";
      var g=$("[data-add]",c); g.parentNode.removeChild(g);
      if(td) td.textContent="lásd a termékoldalon";
      return;
    }
    $(".hti-gombok a",c).href=p.url;
    var cimek=[]; p.v.forEach(function(v){if(cimek.indexOf(v.c)<0)cimek.push(v.c);});
    ar.innerHTML="<b>"+ft(minAr(p))+"</b><span>"+(tobbAr(p)?"-tól · "+cimek.join(" / "):"· "+(KISZ[k]||cimek.join(" / ")))+"</span>";
    if(td) td.innerHTML="<b>"+ft(minAr(p))+"</b>"+(tobbAr(p)?"-tól":"");
  });

  var GOND = [
    {c:"Vakarózás, allergia",alap:"por",melle:["synbio","bubbles"],m:"a por belülről, a falat a bélflórán, a sampon a bőrön"},
    {c:"Emésztés, hasmenés",alap:"por",melle:["synbio"],m:"ha a sima probiotikum eddig nem vált be"},
    {c:"Bűzmirigy",alap:"por",melle:["detox"],m:"éhgyomorra, a porral együtt"},
    {c:"Ízület, idősödő kutya",alap:"marine",melle:["omega"],m:"kollagén + omega-3: a két legjobb barát"},
    {c:"Seb, csípés, kivakart bőr",alap:"help",melle:["mist"],m:"krém a foltra, permet a szőr alá"},
    {c:"Fürdetés, pollen-szezon",alap:"bubbles",melle:["mist"],m:"fürdés után a Mist a két fürdés közti napokra"},
    {c:"Lehelet, fogkő",alap:"dental",melle:["por"],m:"a por az általános alap mellé"},
    {c:"Fakó szőr, száraz bőr",alap:"omega",melle:["por"],m:"zsírsav kívülről látszik, ásvány belülről dolgozik"},
    {c:"Megelőzés, mindennapok",alap:"por",melle:["marine"],m:"vagy Marine, ha a por macerás"},
    {c:"Macska, nyúl, kisállat",alap:"por",melle:["help"],m:"a por minden állatkának; Help a bőrre"}
  ];

  /* --- Mi a gond? chipsor + kiemelés --- */
  var chips=$("#chips"), ajanlat=$("#ajanlat"), aktiv=null;
  GOND.forEach(function(g,i){
    var b=el("button","hm-chip",g.c); b.type="button"; b.setAttribute("aria-pressed","false");
    b.addEventListener("click",function(){valaszt(aktiv===i?null:i);});
    chips.appendChild(b);
  });
  function valaszt(i){
    aktiv=i;
    Array.prototype.forEach.call(chips.children,function(b,k){b.setAttribute("aria-pressed",k===i?"true":"false");});
    var cards=document.querySelectorAll(".hti-kartya");
    Array.prototype.forEach.call(cards,function(c){c.classList.remove("halk","alap","melle");$(".hti-szerep",c).textContent="";});
    if(i==null){ajanlat.classList.remove("on");ajanlat.innerHTML="";return;}
    var g=GOND[i];
    Array.prototype.forEach.call(cards,function(c){
      var p=c.dataset.p;
      if(p===g.alap){c.classList.add("alap");$(".hti-szerep",c).textContent="Alap";}
      else if(g.melle.indexOf(p)>-1){c.classList.add("melle");$(".hti-szerep",c).textContent="Mellé";}
      else c.classList.add("halk");
    });
    ajanlat.innerHTML="<span class=\"cimke alap\">Alap</span> <a href=\"#"+KARTYA[g.alap]+"\">"+NEV[g.alap]+"</a>"
      +" <span class=\"cimke melle\">Mellé</span> "+g.melle.map(function(m){return "<a href=\"#"+KARTYA[m]+"\">"+NEV[m]+"</a>";}).join(", ")
      +" <small>"+g.m+"</small>";
    ajanlat.classList.add("on");
    var first=document.getElementById(KARTYA[g.alap]); if(first) first.scrollIntoView({behavior:"smooth",block:"start"});
  }

  /* --- Gond → megoldás tábla --- */
  var tb=$("#gondtabla tbody");
  GOND.forEach(function(g){
    var tr=el("tr");
    tr.appendChild(el("td","key",g.c));
    tr.appendChild(el("td","","<a href=\"#"+KARTYA[g.alap]+"\">"+NEV[g.alap]+"</a>"));
    tr.appendChild(el("td","",g.melle.map(function(m){return "<a href=\"#"+KARTYA[m]+"\">"+NEV[m]+"</a>";}).join(" + ")+"<small>"+g.m+"</small>"));
    tb.appendChild(tr);
  });

  /* --- Csomagépítő (csak a boltban megtalált termékek) --- */
  var kosar={}; // key -> {vi:variantIndex, db:n}
  var sorok=$("#sorok"), BENT=SORREND.filter(function(k){return P[k];});
  BENT.forEach(function(k){
    var p=P[k], s=el("div","hti-sor"); s.dataset.k=k;
    s.appendChild(el("div","kep","<img src=\""+p.kep+"\" alt=\"\">"));
    s.appendChild(el("div","nev",p.nev+"<small id=\"ar-"+k+"\">"+ft(p.v[0].ar)+"</small>"));
    var vez=el("div","vez");
    if(p.v.length>1){
      var sel=el("select"); sel.setAttribute("aria-label",p.nev+" kiszerelés");
      p.v.forEach(function(v,i){var o=el("option","",v.n+" · "+ft(v.ar)); o.value=i; sel.appendChild(o);});
      sel.addEventListener("change",function(){kosar[k]=kosar[k]||{vi:0,db:0};kosar[k].vi=+sel.value;$("#ar-"+k).textContent=ft(p.v[+sel.value].ar);frissit();});
      vez.appendChild(sel);
    }
    var db=el("div","hti-db","<button type=\"button\" aria-label=\"kevesebb\">−</button><output>0</output><button type=\"button\" aria-label=\"több\">+</button>");
    db.children[0].addEventListener("click",function(){modosit(k,-1);});
    db.children[2].addEventListener("click",function(){modosit(k,1);});
    vez.appendChild(db);
    vez.appendChild(el("span","ar",""));
    s.appendChild(vez);
    sorok.appendChild(s);
  });
  function modosit(k,d){
    kosar[k]=kosar[k]||{vi:0,db:0};
    kosar[k].db=Math.max(0,Math.min(10,kosar[k].db+d));
    frissit();
  }
  function szint(db){for(var i=0;i<SZINT.length;i++)if(db>=SZINT[i].min)return SZINT[i];return null;}
  function irj(s,t){var e=$(s);if(e)e.textContent=t;}
  function frissit(){
    var db=0,resz=0,items=[];
    tetelek=[];
    BENT.forEach(function(k){
      var e=kosar[k]||{vi:0,db:0}, p=P[k], s=sorok.querySelector("[data-k="+k+"]");
      s.querySelector("output").textContent=e.db;
      s.querySelector(".ar").textContent=e.db?ft(p.v[e.vi].ar*e.db):"";
      s.classList.toggle("benne",e.db>0);
      if(e.db){db+=e.db;resz+=p.v[e.vi].ar*e.db;items.push(p.v[e.vi].id+":"+e.db);tetelek.push({id:p.v[e.vi].id,quantity:e.db});}
    });
    var sz=szint(db), kedv=sz?resz*sz.pct/100:0, utan=resz-kedv, szall=utan>=INGYEN?0:GLS;
    var sint=$("#szintek");
    if(sint) Array.prototype.forEach.call(sint.children,function(x){x.classList.toggle("aktiv",!!sz&&+x.dataset.min===sz.min);});
    $("#ures").hidden=db>0; $("#osszeg").hidden=db===0;
    irj("#db",db); irj("#resz",ft(resz));
    irj("#pct",sz?"("+sz.pct+" %)":""); irj("#kedv",kedv?"− "+ft(kedv):"0 Ft");
    irj("#szall",db?(szall?ft(szall):"ingyenes"):ft(GLS));
    irj("#vegso",ft(db?utan+szall:0));
    var sk=$("#sav-kedv");
    if(sk){
      var kov=null; for(var i=SZINT.length-1;i>=0;i--){if(db<SZINT[i].min){kov=SZINT[i];break;}}
      if(kov){sk.classList.remove("kesz");sk.firstChild.textContent="Még "+(kov.min-db)+" termék, és "+kov.pct+" % kedvezmény";sk.querySelector("i").style.width=Math.min(100,db/kov.min*100)+"%";}
      else if(SZINT.length){sk.classList.add("kesz");sk.firstChild.textContent="A legnagyobb kedvezményt kapod: "+SZINT[0].pct+" %";sk.querySelector("i").style.width="100%";}
    }
    var ss=$("#sav-szall");
    if(db&&szall===0){ss.classList.add("kesz");ss.firstChild.textContent="Ingyenes szállítás: megvan";ss.querySelector("i").style.width="100%";}
    else{ss.classList.remove("kesz");ss.firstChild.textContent="Még "+ft(INGYEN-utan)+" az ingyenes szállításig";ss.querySelector("i").style.width=Math.min(100,utan/INGYEN*100)+"%";}
    var a=$("#kosar");
    // a lépcsőt a Function adja (kosár-attribútum), kód nincs: a permalink kód nélkül megy, és aktív kedvezménynél csak tartalék-út
    if(db){a.setAttribute("aria-disabled","false");a.href="/cart/"+items.join(",");a.textContent=db===1?"Kosárba (1 termék)":"Kosárba a csomaggal · "+ft(utan);}
    else{a.setAttribute("aria-disabled","true");a.href="#";a.textContent="Kosárba a csomaggal";}
  }
  var tetelek=[], megy=false;
  frissit();

  /* aktív kedvezménynél a gomb a kosár-API-n át tesz a kosárba, mert a permalink nem tud attribútumot adni, a Function pedig
     csak a _humac_csomag=iranytu kosárnak ad lépcsőt; bármi hiba → a permalink (kedvezmény nélkül, de a kosár megtelik) */
  $("#kosar").addEventListener("click",function(ev){
    var a=this;
    if(!D.aktiv||!tetelek.length) return;
    ev.preventDefault();
    if(megy) return;
    megy=true; a.setAttribute("aria-disabled","true"); a.textContent="Kosárba teszem…";
    var tartalek=a.href;
    function post(u,b){
      return fetch(u,{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify(b)})
        .then(function(r){if(!r.ok)throw new Error(r.status);return r;});
    }
    post("/cart/add.js",{items:tetelek})
      .then(function(){return post("/cart/update.js",{attributes:{_humac_csomag:"iranytu"}});})
      .then(function(){location.href="/cart";},function(){location.href=tartalek;});
  });

  /* kártya „Csomagba” gomb */
  var toast=$("#toast"), tid;
  Array.prototype.forEach.call(document.querySelectorAll("[data-add]"),function(b){
    b.addEventListener("click",function(){
      var k=b.dataset.add; modosit(k,1);
      b.classList.add("volt"); b.textContent="A csomagban ("+kosar[k].db+")";
      toast.innerHTML=NEV[k]+" a csomagban · <u>Ugrás a csomaghoz ↓</u>"; toast.classList.add("on");
      clearTimeout(tid); tid=setTimeout(function(){toast.classList.remove("on");},2600);
    });
  });
  toast.addEventListener("click",function(){$("#csomag").scrollIntoView({behavior:"smooth"});});
  toast.style.pointerEvents="auto";
})();
